import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  StyledMetricCard,
  MetricTitle,
  MetricTitleLarge,
  MetricValue,
  IconWrapper,
} from './styles';
import type { MetricCardProps } from './types';

const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  icon,
  iconColor = '#2D6CCA',
  onClick,
  isSelected = false,
  variant = 'default',
}) => {
  if (variant === 'simple') {
    return (
      <StyledMetricCard isSelected={isSelected} cardColor={iconColor} onClick={onClick}>
        <MetricTitleLarge>{title}</MetricTitleLarge>
      </StyledMetricCard>
    );
  }

  return (
    <StyledMetricCard isSelected={isSelected} cardColor={iconColor} onClick={onClick}>
      <MetricTitle>{title}</MetricTitle>
      {value !== undefined && <MetricValue level={2}>{value}</MetricValue>}
      {icon && (
        <IconWrapper iconColor={iconColor}>
          <FontAwesomeIcon icon={icon} />
        </IconWrapper>
      )}
    </StyledMetricCard>
  );
};

export default MetricCard;
